import React from "react";
import { useRevisionFormContext } from "components/brief/reviewer/revision/RevisionForm.lib.context";
import View from "components/brief/reviewer/revision/content/RevisionContent.view";

const RevisionContent = ({
  flow,
  currentSection,
  indexSections,
  visibleSections,
  onClickEditProposal,
  onClickNextSection,
  onClickSelectSection,
  onClickSaveRevision,
  isSaving,
}) => {

  const {
    proposal,
    allowComments,
    setGlobalAdditionalComments,
  } = useRevisionFormContext();

  const isStaticSection = !!currentSection.isStatic;
  const isExtraSection = !!currentSection.isExtra;
  const showReadOnlyEmptyState = !isStaticSection && !isExtraSection && visibleSections.length === 0;

  return (
    <View
      flow={flow}
      proposal={proposal}
      currentSection={currentSection}
      indexSections={indexSections}
      allowComments={allowComments}
      isSaving={isSaving}
      showReadOnlyEmptyState={showReadOnlyEmptyState}
      setGlobalAdditionalComments={setGlobalAdditionalComments}
      onClickEditProposal={onClickEditProposal}
      onClickNextSection={onClickNextSection}
      onClickSelectSection={onClickSelectSection}
      onClickSaveRevision={onClickSaveRevision}
    />
  );

}

export default RevisionContent;
